'use strict';

import { connectPagination, Hits, Pagination } from 'react-instantsearch-dom';
import NoResults from './NoResults';
import CurrentRefinements from './CurrentRefinements';
import Course from './Course';

const ResultsComponent = () => {
	return (
		<div>
			<CurrentRefinements />
			
			<Hits hitComponent={ Course } />
			
			<NoResults />
			
			<div className="tailwind">
				<Pagination />
			</div>
		</div>
	);
};

export const Results = connectPagination(ResultsComponent);

export default Results;
